import styled, { css } from 'styled-components';
import { theme, toRem } from 'design';

interface ILayoutProps {
  hideNav?: boolean; // removes padding from layout component, for account setup
  hideHeader?: boolean; // removes padding from layout component, for connect integrations setup
  navOpen?: boolean;
}

export const AppLayout = styled.div<Partial<ILayoutProps>>`
  position: relative;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100vh;
  padding-top: ${toRem(theme.header.height)};
  background-color: ${theme.color.white};
  transition: padding ${theme.transition.nav};

  @media (min-width: ${theme.breakpoint.small}px) {
    padding-left: ${toRem(theme.nav.width.closed)};

    ${({ navOpen }) =>
      navOpen &&
      css`
        padding-left: ${toRem(theme.nav.width.open)};
      `}
  }

  ${({ hideNav }) =>
    hideNav &&
    css`
      && {
        padding-left: 0;
      }
    `}

  ${({ hideHeader }) =>
    hideHeader &&
    css`
      && {
        padding-top: 0;
      }
    `}
`;

export const AppContentLayout = styled.div`
  display: block;
  flex-grow: 1;
  flex-flow: row nowrap;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
`;

export const AppContent = styled.main<{ darkMode?: boolean }>`
  position: relative;
  display: flex;
  flex-flow: column nowrap;
  justify-content: flex-start;
  align-items: center;
  flex-grow: 1;
  width: 100%;
  min-height: 100%;
  margin-bottom: ${toRem(theme.layout.gutter.small)};
  transition: width ${theme.transition.nav};
  background: ${({ darkMode }) => (darkMode ? theme.color.neutral[50] : 'inherit')};
`;

export const MobileAction = styled.div`
  flex-flow: column nowrap;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: ${toRem(22)};
  padding-top: ${toRem(33)};
  border-top: ${toRem(1)} solid rgba(255, 255, 255, 0.11);

  button {
    width: fit-content;
  }

  @media (min-width: ${theme.breakpoint.small}px) {
    display: none;
  }
`;
